import { useRequirementsViewStore } from '@/stores/requirementsViewStore'
import { RequirementsNotes } from '../RequirementsNotes'
import { ViewToolbar } from '../filters/ViewToolbar'
import { ScopeBreadcrumb } from '../ScopeBreadcrumb'
import { DocumentTOC } from '../document/DocumentTOC'
import { DocumentHeader } from '../document/DocumentHeader'
import type { ViewContainerProps } from './sharedProps'

/**
 * Document (PRD) view. Layout:
 *   TOC + at-a-glance (left, 256px) | toolbar + breadcrumb + header + body
 *
 * The left rail combines the on-this-page outline with the document
 * stats (completeness, priority, status, counts) — replacing the old
 * right-side Sidekick panel and giving the doc body the full remaining
 * width for editorial reading.
 */
export function DocumentView({
  requirements, scopedRequirements,
  tree, scopedNode, themes, personaIndex,
  updateRequirement, deleteRequirement,
  createBlock, reorderSiblings,
  errorBanner,
}: ViewContainerProps) {
  const clearScope = useRequirementsViewStore(s => s.scopeTo)

  return (
    <>
      <DocumentTOC tree={tree} requirements={scopedRequirements} />
      <div className="flex-1 min-w-0 flex flex-col min-h-0">
        <ViewToolbar requirements={requirements} themes={themes} />
        <div className="overflow-y-auto flex-1">
          {scopedNode && (
            <ScopeBreadcrumb node={scopedNode} onClear={() => clearScope(null)} />
          )}
          {errorBanner}
          <div style={{ maxWidth: 760, margin: '0 auto', padding: '32px 24px 0' }}>
            <DocumentHeader totalCount={scopedRequirements.length} />
          </div>
          <RequirementsNotes
            requirements={scopedRequirements}
            themes={themes}
            personaIndex={personaIndex}
            onUpdate={updateRequirement}
            onCreate={createBlock}
            onDelete={deleteRequirement}
            onReorder={reorderSiblings}
          />
        </div>
      </div>
    </>
  )
}
